'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { useAppStore } from '@/stores';
import { useEffect } from 'react';

export function ThemeProvider({ children }: { children: React.ReactNode }): JSX.Element {
	const { userPreferences } = useAppStore();

	useEffect(() => {
		// Sync theme with system preference
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		const handleChange = (e: MediaQueryListEvent) => {
			if (userPreferences.theme === 'system') {
				document.documentElement.classList.toggle('dark', e.matches);
			}
		};

		mediaQuery.addEventListener('change', handleChange);
		return () => mediaQuery.removeEventListener('change', handleChange);
	}, [userPreferences.theme]);

	return (
		<NextThemesProvider
			attribute="class"
			defaultTheme={userPreferences.theme}
			enableSystem
			disableTransitionOnChange
		>
			{children}
		</NextThemesProvider>
	);
}
